
import axios from "axios";
import { store } from "store";
import { OutputBaseProps, PaginationProps } from "utils/types/API";
import { FormItemProps } from ".";
import { loading, index, options, accessAllow } from "store/form";

interface ApiFormInputProps {
    page?: number;
    pageSize?: number;
    q?: string;
    workflowIds?: number[];
    fields?: string;
}

type ApiFormOutputProps = OutputBaseProps<{ list: FormItemProps[]; pagination?: PaginationProps; }>

export const apiFormIndex = async (data: ApiFormInputProps) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiFormOutputProps>("/api/forms", { params: data }))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(index({ data: res.data.list, pagination: res.data.pagination }));
    }
    return res;
};

export const apiFormOptions = async (data: { q?: string; }) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiFormOutputProps>("/api/forms", { params: { ...data, fields: "id,code,name" } }))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(options({ data: res.data.list }));
    }
    return res;
};


export const apiFormAccessAllow = async () => {
    const res = (await axios.get<ApiFormOutputProps>("/api/form/check-access-controll/all"))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(accessAllow({ data: res.data.list }));
    }
    return res;
}; 